import GoogleAsspAd from './googleAd'
import GoogleAdsenseAd from "./googleAdsense"
import TaboolaAd from "./taboolaAd"
import brightcomAd from "./brightcomAd/brightcomAd"
import adxAd from "./adxAd"
import xpsAd from "./xpsAd"
import baiduAsspAd from "./baiduAd"
import SOHUZH from "./SOHUZH"
import MomagicAd from "./MomagicAd/MomagicAd"
import OnemobAd from "./OnemobAd"
import VidoomyAd from "./VidoomyAd"
import clickadillaBannerAd from "./clickadillaBannerAd"

var getAsspAd = function (opt) {
    var data = opt.data
    switch(data && data.adType) {
        case 'BAIDUUNION':
            baiduAsspAd(opt);
            break
        case 'GOOGLEMANAGER':
            GoogleAsspAd(opt);
            break
        case 'XPS':
            xpsAd(opt);
            break
        case 'GOOGLEADSENSE':
            GoogleAdsenseAd(opt);
            break
        case 'TABOOLA':
            TaboolaAd(opt);
            break
        // 海外广告brightcom，不支持异步js加载
        case 'brightcom':
            brightcomAd(opt);
            break
        case 'adx':
            adxAd(opt);
            break
        case 'SOHUZH':
            SOHUZH(opt);
            break
        case 'MOMAGIC':
            MomagicAd(opt);
            break
        // 海外onemob的广告
        case 'ONEMOB':
            OnemobAd(opt);
            break
        // 海外vidoomy的广告，无固定位置
        case 'vidoomy':
            VidoomyAd(opt);
            break
        // 海外clickadillaBannerAd的广告，banner类型
        case 'clickadillaBanner':
            clickadillaBannerAd(opt);
            break
        default:
            break
    }
}

export default getAsspAd;